import {styled} from '@mui/material/styles';
import TableCell from '@mui/material/TableCell';
const MythicStyledTableCell = styled(TableCell, {})({
  padding: "2px 0 2px 10px !important",
});
export default MythicStyledTableCell;
